import api from './api';

export interface TPSData {
  id: string;
  name: string;
  area: number;
  geometry?: any;
}

export interface FPSData {
  gid: number;
  tps_id: string;
  plot_number: string;
  area: number;
  geometry?: any;
}

export interface RoadData {
  id: string;
  name: string;
  road_type: string;
  width: number;
  geometry?: any;
}

export interface SearchResult {
  type: 'fps' | 'tps' | 'road';
  id: string;
  name: string;
  description: string;
}

export class GeospatialService {
  async getTPS(limit = 10, includeGeometry = false): Promise<TPSData[]> {
    const params = new URLSearchParams({
      limit: limit.toString(),
      include_geometry: includeGeometry.toString(),
    });
    const response = await api.get(`/api/tps?${params}`);
    return response.data;
  }

  async getTPSById(id: string, includeGeometry = true): Promise<TPSData> {
    const params = new URLSearchParams({
      include_geometry: includeGeometry.toString(),
    });
    const response = await api.get(`/api/tps/${id}?${params}`);
    return response.data;
  }

  async getFPS(limit = 10, tpsId?: string, includeGeometry = false): Promise<FPSData[]> {
    const params = new URLSearchParams({
      limit: limit.toString(),
      include_geometry: includeGeometry.toString(),
    });
    if (tpsId) {
      params.append('tps_id', tpsId);
    }
    const response = await api.get(`/api/fps?${params}`);
    return response.data;
  }

  async getFPSByGID(gid: string, includeGeometry = true): Promise<FPSData> {
    const params = new URLSearchParams({
      include_geometry: includeGeometry.toString(),
    });
    const response = await api.get(`/api/fps/${gid}?${params}`);
    return response.data;
  }

  async getRoads(limit = 10, roadType?: string, includeGeometry = false): Promise<RoadData[]> {
    const params = new URLSearchParams({
      limit: limit.toString(),
      include_geometry: includeGeometry.toString(),
    });
    if (roadType) {
      params.append('road_type', roadType);
    }
    const response = await api.get(`/api/roads?${params}`);
    return response.data;
  }

  async searchFeatures(query: string, type: 'fps' | 'tps' | 'road' = 'fps', limit = 10): Promise<SearchResult[]> {
    const params = new URLSearchParams({
      q: query,
      type,
      limit: limit.toString(),
    });
    const response = await api.get(`/api/search?${params}`);
    return response.data;
  }

  async getHealthCheck() {
    const response = await api.get('/health');
    return response.data;
  }

  async getAPIStats() {
    const response = await api.get('/apis/stats');
    return response.data;
  }
}

export const geospatialService = new GeospatialService();